module.exports = __webpack_public_path__ + "img/cobalt_banner.jpg";